import {
  Leegality, Language, VersionHistory,
  AccessDenied,
  ConsentIn,
  LogoInWhite,
} from '@assets';
import { convertObject } from '@utils/general';

export const ImageDictionary = {
  LeegalityLogo: {
    src: Leegality,
    alt: 'Leegality Icon',
  },
  Language: {
    src: Language,
    alt: 'Change Language',
  },
  VersionHistory: {
    src: VersionHistory,
    alt: 'Version History',
  },
  AccessDenied: {
    src: AccessDenied,
    alt: 'Access Denied',
  },
  ConsentIn: {
    src: ConsentIn,
    alt: 'ConsentIn Icon',
  },
  LogoInWhite: {
    src: LogoInWhite,
    alt: 'ConsentIn Icon',
  },
};

export const ImageKeys = convertObject(ImageDictionary);
